import script from "./SideBarLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBarLink.vue?vue&type=script&setup=true&lang=ts"

import "./SideBarLink.vue?vue&type=style&index=0&id=4deed7dc&sass=true&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4deed7dc"]])

export default __exports__